// tslint:disable:max-line-length

/************************************************************************************/
/* WARNING: This file is generated automatically. Don't edit it by hand             */
/************************************************************************************/

import type * as rest from "../rest";
import type * as t from "./nonauthenticated.generated.types";

function enc(s: any) { return encodeURIComponent("" + s); }

export interface INonauthenticated {
    /** Start mock job */
    testMockJob(req: t.ITestMockJobReq): Promise<t.ITestMockJobRes>;

    /** Gets list of available offices */
    getOffices(req: t.IGetOfficesReq): Promise<t.IGetOfficesRes>;

    /** Gets week view */
    getWeek(req: t.IGetWeekReq): Promise<t.IGetWeekRes>;

    /** Gets multi-week view */
    getMultiWeek(req: t.IGetMultiWeekReq): Promise<t.IGetMultiWeekRes>;

    /** Get captcha data to display on registration form */
    getCaptcha(req: t.IGetCaptchaReq): Promise<t.IGetCaptchaRes>;

    /** Get data about pending registration */
    getRegistrationByToken(req: t.IGetRegistrationByTokenReq): Promise<t.IGetRegistrationByTokenRes>;

    /** Updates pending registration */
    updateRegistrationByToken(req: t.IUpdateRegistrationByTokenReq): Promise<t.IUpdateRegistrationByTokenRes>;

}

export class Nonauthenticated implements INonauthenticated {

    private client: rest.IApiClient;

    constructor(client: rest.IApiClient) { this.client = client; }

    /** Start mock job */
    public async testMockJob(req: t.ITestMockJobReq): Promise<t.ITestMockJobRes> {
        const reqx: any = req;
        const url = `/api/v1.0/nonauthenticated/test-job`;
        return (await this.client.post(url, reqx));
    }

    /** Gets list of available offices */
    public async getOffices(req: t.IGetOfficesReq): Promise<t.IGetOfficesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/nonauthenticated/offices`;
        return (await this.client.get(url, reqx));
    }

    /** Gets week view */
    public async getWeek(req: t.IGetWeekReq): Promise<t.IGetWeekRes> {
        const reqx: any = req;
        const url = `/api/v1.0/nonauthenticated/week`;
        return (await this.client.get(url, reqx));
    }

    /** Gets multi-week view */
    public async getMultiWeek(req: t.IGetMultiWeekReq): Promise<t.IGetMultiWeekRes> {
        const reqx: any = req;
        const url = `/api/v1.0/nonauthenticated/multi-week`;
        return (await this.client.get(url, reqx));
    }

    /** Get captcha data to display on registration form */
    public async getCaptcha(req: t.IGetCaptchaReq): Promise<t.IGetCaptchaRes> {
        const reqx: any = req;
        const url = `/api/v1.0/nonauthenticated/registations-get-captcha`;
        return (await this.client.post(url, reqx));
    }

    /** Get data about pending registration */
    public async getRegistrationByToken(req: t.IGetRegistrationByTokenReq): Promise<t.IGetRegistrationByTokenRes> {
        const reqx: any = req;
        const url = `/api/v1.0/nonauthenticated/registations/${enc(req.token)}`;
        delete reqx.token;
        return (await this.client.get(url, reqx));
    }

    /** Updates pending registration */
    public async updateRegistrationByToken(req: t.IUpdateRegistrationByTokenReq): Promise<t.IUpdateRegistrationByTokenRes> {
        const reqx: any = req;
        const url = `/api/v1.0/nonauthenticated/registations`;
        return (await this.client.post(url, reqx));
    }

}
